import React from 'react'
import { Dialog } from 'primereact/dialog';

const ModalNetwork = ({
    open = false,
    onClose = () => console.log('onClose'),

}) => {
    return (
        <Dialog visible={open} style={{ width: '500px' }} onHide={() => onClose()} draggable={false} resizable={false} closable={false}>
            <div className="bModal bCard" id="failModal" style={{ display: 'block' }}>
                <div className="bInner">
                    <div className="bTitle">
                        <span>ยกเลิกการนัดหมายสำเร็จ</span>
                        <p>
                            แต่เกิดข้อผิดพลาดในการคืน point<br />(40402)
                        </p>
                    </div>
                    <div className="bBtn">
                        <button className="btn btnCloseModal" onClick={onClose}>ตกลง</button>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default ModalNetwork